export default "__VITE_ASSET__DRxLdu_o__";